module.exports = __webpack_public_path__ + "img/logo-aliments-sante-horizontal.499f49d1.svg";